// @flow
import * as React from 'react'
import DesktopSelector from '../DesktopSelector'
import MobileSelector from '../MobileSelector'
import { isDesktopBrowser } from '../../../utils'
import { Container } from './elements'

type BaseProps = {
  appearance?: 'desktop' | 'mobile',
}
export type RenderProps = BaseProps & {
  open: () => void,
  close: () => void,
}
export type Props = BaseProps & {
  mobileTitle?: string,
  placement?: string,
  color?: string,
  width?: string,
  wrapper?: string | React.ComponentType<any>,
  renderButton: (params: RenderProps) => React.Node,
  renderSelector: (params: RenderProps) => React.Node,
}

const SelectorButton = (props: Props) => {
  const [showed, setShowed] = React.useState(false)

  const params = {
    ...props,
    selectorShowed: showed,
    open: () => setShowed(true),
    close: () => setShowed(false),
  }

  if (!params.appearance) {
    params.appearance = isDesktopBrowser() ? 'desktop' : 'mobile'
  }

  return (
    <Container>
      {params.appearance === 'desktop' ? (
        <DesktopSelector {...params} />
      ) : (
        <MobileSelector {...params} />
      )}
    </Container>
  )
}

SelectorButton.defaultProps = {
  placement: 'bottom',
  color: 'white',
  width: 'auto',
}

export default SelectorButton
